var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Article',{attrs:{"title":_vm.title,"header":false}},[_c('HomeBanner',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t("home_page.text_1")))]},proxy:true},{key:"subtitle",fn:function(){return [_vm._v("\n       "+_vm._s(_vm.$t("home_page.text_2"))+" "),_c('span',{staticClass:"lead"},[_vm._v(_vm._s(_vm.$t("home_page.text_3")))])]},proxy:true}])}),_vm._v(" "),_c('HomeIntro',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"t1"},[_vm._v(_vm._s(_vm.$t("home_page.text_4"))+" ")]),_vm._v(" "),_c('span',{staticClass:"t2"},[_vm._v(_vm._s(_vm.$t("home_page.text_5")))])]},proxy:true},{key:"subtitle",fn:function(){return [_c('span',{staticClass:"t1"},[_vm._v(_vm._s(_vm.$t("home_page.text_6")))])]},proxy:true},{key:"paragraph",fn:function(){return [_c('p',[_vm._v(_vm._s(_vm.$t("home_page.text_7")))])]},proxy:true},{key:"action",fn:function(){return [_c('router-link',{staticClass:"ssc_button none",attrs:{"to":"/hire-us","target":"_self"}},[_c('span',[_vm._v(_vm._s(_vm.$t("home_page.text_8")))])])]},proxy:true}])}),_vm._v(" "),_c('HomeHowItWork',{attrs:{"steps":{
       'step1': {
         'name': _vm.$t('home_page.text_9'),
         'icon': 'nat-light-bulb2'
       },
       'step2': {
         'name': _vm.$t('home_page.text_10'),
         'icon': 'nat-stats-1'
       },
       'step3': {
         'name': _vm.$t('home_page.text_11'),
         'icon': 'nat-graphic-design'
       },
       'step4': {
         'name': _vm.$t('home_page.text_12'),
         'icon': 'nat-computer-design-2'
       },
       'step5': {
         'name': _vm.$t('home_page.text_13'),
         'icon': 'nat-rocket2'
       }
     }},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h2',{staticClass:"t1"},[_vm._v(_vm._s(_vm.$t('home_page.text_14'))+" ")]),_vm._v(" "),_c('h2',{staticClass:"t2"},[_vm._v(_vm._s(_vm.$t('home_page.text_15')))])]},proxy:true},{key:"subtitle",fn:function(){return [_c('p',{staticClass:"t3"},[_vm._v(_vm._s(_vm.$t('home_page.text_16')))])]},proxy:true}])}),_vm._v(" "),_c('Clients',{attrs:{"clients":[
       'mcdonalds.png',
       'fca.png',
       'hsbc.png',
       'indeed.png',
       'thomson.png',
       'salesforce.png' ]},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"t1"},[_vm._v(_vm._s(_vm.$t('home_page.text_17'))+" ")]),_c('span',{staticClass:"t2"},[_vm._v(" "+_vm._s(_vm.$t('home_page.text_18')))])]},proxy:true},{key:"subtitle",fn:function(){return [_c('span',{staticClass:"t1"},[_vm._v(_vm._s(_vm.$t('home_page.text_19')))])]},proxy:true},{key:"action",fn:function(){return [_c('router-link',{staticClass:"ssc_button none",attrs:{"to":"/hire-us","target":"_self"}},[_c('span',[_vm._v(_vm._s(_vm.$t('home_page.text_20')))])])]},proxy:true}])}),_vm._v(" "),_c('Statics',{attrs:{"statics":[
       {
         'number': 100,
         'symbol': '+',
         'title': _vm.$t('home_page.text_21')
       },
       {
         'number': 3,
         'symbol': '%',
         'title': _vm.$t('home_page.text_22')
       },
       {
         'number': 135,
         'symbol': '+',
         'title': _vm.$t('home_page.text_23')
       },
       {
         'number': 100,
         'symbol': '%',
         'title': _vm.$t('home_page.text_24')
       }
     ]}}),_vm._v(" "),_c('Locations')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddce814","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Views/Home.vue
// module id = null
// module chunks = 